import { z } from "zod";

export const loyaltyReasonSchema = z.enum([
	"earn_purchase",
	"earn_visit",
	"earn_manual",
	"redeem",
	"adjustment",
]);
export type LoyaltyReason = z.infer<typeof loyaltyReasonSchema>;

export const loyaltySettingsApiSchema = z.object({
	clinic_id: z.string().uuid(),
	enabled: z.boolean(),
	earn_points_per_amount: z.number(),
	amount_unit: z.number(),
	redeem_value_per_point: z.number(),
	currency: z.string(),
	updated_at: z.string().datetime(),
});
export type LoyaltySettingsApi = z.infer<typeof loyaltySettingsApiSchema>;

export const updateLoyaltySettingsInputSchema = z.object({
	enabled: z.boolean().optional(),
	earn_points_per_amount: z.number().nonnegative().optional(),
	amount_unit: z.number().positive().optional(),
	redeem_value_per_point: z.number().nonnegative().optional(),
	currency: z.string().max(8).optional(),
});
export type UpdateLoyaltySettingsInput = z.infer<
	typeof updateLoyaltySettingsInputSchema
>;

export const loyaltyTransactionApiSchema = z.object({
	id: z.string().uuid(),
	clinic_id: z.string().uuid(),
	patient_id: z.string().uuid(),
	points: z.number().int(),
	reason: loyaltyReasonSchema,
	description: z.string().nullable(),
	invoice_id: z.string().uuid().nullable(),
	created_by_member_id: z.string().uuid().nullable(),
	created_by_name: z.string().nullable(),
	created_at: z.string().datetime(),
});
export type LoyaltyTransactionApi = z.infer<typeof loyaltyTransactionApiSchema>;

/** A patient's loyalty snapshot — balance + ledger + the clinic settings. */
export const loyaltySummaryApiSchema = z.object({
	balance: z.number().int(),
	settings: loyaltySettingsApiSchema,
	transactions: z.array(loyaltyTransactionApiSchema),
});
export type LoyaltySummaryApi = z.infer<typeof loyaltySummaryApiSchema>;

export const earnPointsInputSchema = z.object({
	patient_id: z.string().uuid(),
	points: z.number().int().positive(),
	reason: z
		.enum(["earn_purchase", "earn_visit", "earn_manual"])
		.default("earn_manual"),
	description: z.string().max(300).optional(),
	invoice_id: z.string().uuid().optional(),
});
export type EarnPointsInput = z.infer<typeof earnPointsInputSchema>;

export const redeemPointsInputSchema = z.object({
	patient_id: z.string().uuid(),
	points: z.number().int().positive(),
	description: z.string().max(300).optional(),
});
export type RedeemPointsInput = z.infer<typeof redeemPointsInputSchema>;

export const adjustPointsInputSchema = z.object({
	patient_id: z.string().uuid(),
	/** Signed manual correction. */
	points: z.number().int(),
	description: z.string().max(300).optional(),
});
export type AdjustPointsInput = z.infer<typeof adjustPointsInputSchema>;
